import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Collapse, Nav, Tab } from "react-bootstrap";
import MyPagination from "../../Common/MyPagination";
import { proxyAPI } from "../../proxyAPI.ts";
import Input from "../../Builder/nodes/Logic/Inputs/Input";
import ActivationIcon from "../../../assets/icons/opt-in-out.svg2";
import ReplyHandlerIcon from "../../../assets/icons/omni-channel.svg2";
import LogicIcon from "../../../assets/icons/library_logic.svg2";
import CanvasCard from "./CanvasCard.tsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";

export default function Sidebar({ setDragged }) {
  const [components, setComponents] = useState([]);
  const [total, setTotal] = useState(0);
  const [resetPagination, setResetPagination] = useState(Date.now());
  const [searchParams, setSearchParams] = useSearchParams();
  const [show, setShow] = useState(true);

  const loader = async (page = 0, perPage = 10) => {
    const data = await proxyAPI({
      prefix: "logic/workflows/api",
      url: `/list-projects?${searchParams.toString()}&offset=${
        page * perPage
      }&limit=${perPage}`,
    });
    if (data?.projects) {
      setTotal(data.total);
      setComponents(data.projects);
    }
  };

  const fixedComponents = [
    { Label: "Manual", UUID: "Manual", isActivation: true },
    { Label: "Email", UUID: "Email", isActivation: true },
    { Label: "Sms", UUID: "Sms", isActivation: true },
    // { Label: "Voice", UUID: "Voice", isActivation: true },
    // { Label: "RCS", UUID: "RCS", isActivation: true },
  ];

  return (
    <div className="position-relative">
      <button
        type="button"
        className={`btn position-absolute top-0 mt-2 z-1 ${
          show ? "end-0" : "start-0"
        }`}
        onClick={() => setShow(!show)}
      >
        <FontAwesomeIcon icon={faBars} />
      </button>
      <Collapse in={show} dimension="width">
        <div className="h-100">
          <div
            className="mx-0 bg-white p-3 rounded-end-3 h-100"
            style={{ width: 400 }}
          >
            <div className="my-3 d-flex justify-content-between">
              <h4 className="fw-bold">WORKFLOW TOOLBOX</h4>
            </div>
            <span>Drag a component to add it to your project</span>

            <Tab.Container
              id="toolbox-tabs"
              defaultActiveKey="first"
              mountOnEnter
              unmountOnExit
            >
              <Nav variant="tabs" className="my-3">
                <Nav.Item>
                  <Nav.Link eventKey="first">TEMPLATES</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="second">COMPONENTS</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="third">MODULES</Nav.Link>
                </Nav.Item>
              </Nav>
              <Tab.Content>
                <Tab.Pane eventKey="first">
                  <div className="row m-0 g-2">
                    {(
                      JSON.parse(localStorage.getItem("projectTemplates")) || []
                    ).map((component) => (
                      <CanvasCard
                        label={`Comp: ${
                          Object.keys(component.layers[1].models).length
                        }`}
                        key={component.UUID}
                        component={component}
                        setDragged={() => setDragged(component)}
                      />
                    ))}
                  </div>
                </Tab.Pane>
                <Tab.Pane eventKey="second">
                  <Input
                    inputType="radio"
                    options={[
                      { value: "", label: "ALL" },
                      { value: "system", label: "SYSTEM" },
                      { value: "custom", label: "CUSTOM" },
                    ]}
                    value={[""]}
                    onChange={() => {}}
                  />
                  <Tab.Container id="components-tabs" defaultActiveKey={0}>
                    <Nav variant="tabs" className="row g-2 m-0 mx-n1 mb-3">
                      {[
                        {
                          label: "Activation Components",
                          icon: ActivationIcon,
                        },
                        {
                          label: "Logic Components",
                          icon: LogicIcon,
                        },
                        {
                          label: "Reply Handler Components",
                          icon: ReplyHandlerIcon,
                        },
                      ].map((item, idx) => (
                        <div className="col-4">
                          <Nav.Item>
                            <Nav.Link
                              eventKey={idx}
                              className="border border-primary rounded-3 text-center text-xs"
                              style={{ height: 100 }}
                            >
                              <div className="mb-2">
                                <item.icon width={40} />
                              </div>
                              <div>{item.label}</div>
                            </Nav.Link>
                          </Nav.Item>
                        </div>
                      ))}
                    </Nav>
                    <Tab.Content>
                      <Tab.Pane eventKey={0}>
                        <div className="row m-0 g-2">
                          {[...fixedComponents].map((component) => (
                            <CanvasCard
                              key={component.UUID}
                              component={component}
                              setDragged={() => setDragged(component)}
                            />
                          ))}
                        </div>
                        <MyPagination
                          total={total}
                          onPaginate={loader}
                          key={resetPagination}
                        />
                      </Tab.Pane>
                      <Tab.Pane eventKey={1}>
                        <div className="row m-0 g-2">
                          {[...components].map((component) => (
                            <CanvasCard
                              key={component.UUID}
                              component={component}
                              setDragged={() => setDragged(component)}
                            />
                          ))}
                        </div>
                        <MyPagination
                          total={total}
                          onPaginate={loader}
                          key={resetPagination}
                        />
                      </Tab.Pane>
                      <Tab.Pane eventKey={2}>Reply Handler Components</Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>
                </Tab.Pane>
                <Tab.Pane eventKey="third">Third tab content</Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </div>
        </div>
      </Collapse>
    </div>
  );
}
